/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { RejectionLossCode } from '../enums/rejection-loss-code';
import { CandidateEntity } from './candidate-entity';
export class OppCandMLRecEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  candidateOpportunityId: string | null = null;
  createdAt: string | null = null;
  dsMatchSummary: Record<string, unknown> | null = null;
  id: string = '';
  mlLossCode: RejectionLossCode | null = null;
  opportunityId: string | null = null;
  updatedAt: string | null = null;
  updatedBy: string | null = null;
  static override key = 'OppCandMLRec';
  static override get schema() {
    return {
      candidate: CandidateEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'OppCandMLRec' in input
    ) {
      const { OppCandMLRec: wrapped, ...rest } = input as {
        OppCandMLRec: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}